var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#743BBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.268 8.00218C15.0686 8.00218 14.8774 8.08139 14.7364 8.22238L14.3391 8.61969L15.4023 9.68289L15.7996 9.28558C15.9406 9.14459 16.0198 8.95337 16.0198 8.75398C16.0198 8.55459 15.9406 8.36337 15.7996 8.22238C15.6586 8.08139 15.4674 8.00218 15.268 8.00218ZM16.5082 9.99423C16.8372 9.6653 17.022 9.21916 17.022 8.75398C17.022 8.28879 16.8372 7.84266 16.5082 7.51373C16.1793 7.18479 15.7332 7 15.268 7C14.8028 7 14.3567 7.18479 14.0277 7.51373L13.2764 8.2651C13.2764 8.26502 13.2763 8.26519 13.2764 8.2651C13.2763 8.26519 13.2759 8.26554 13.2758 8.26562L7.14677 14.3947C7.05279 14.4887 7 14.6161 7 14.749V16.5389C7 16.8157 7.22435 17.04 7.50109 17.04H9.2549C9.3878 17.04 9.51526 16.9872 9.60923 16.8932L16.5082 9.99423ZM14.6936 10.3915L13.6304 9.32834L8.00218 14.9566V16.0378H9.04735L14.6936 10.3915Z",
    fill: "#743BBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIcon);
export default __webpack_public_path__ + "static/media/progressIcon.e4ef45fc5d02a9a302d8ed487c5e8841.svg";
export { ForwardRef as ReactComponent };